<template>
    <div>
        <div class="panel-tag mt-2">
            {{__t("ATTACH_AUTO_DELIVERY")}}
        </div>
        <div>
            <yes_no
                key="ENABLE_DELIVERY"
                title="ENABLE_DELIVERY"
                @input="on_change_value"
                v-model="enable_delivery"
            >
            </yes_no>
        </div>

        <div class="select_delivery_locations mb-5 pb-5" v-if="enable_delivery">
            <div class="form-group mt-5">
                <label class="form-label" for="shipping_delivery">
                    <sup v-if="!is_rest_same">

                        <span class="badge badge-danger ml-2">
                            {{__t('REST_NOT_EQUAL')}}
                        </span>
                    </sup>
                    {{__t("DELIVERY_LOCATION")}}
                </label>

                <div class="" v-if="this.delivery_locations.length > 0">
                    <v-select
                        v-model="active_location"
                              class="imc_reasons"
                              id="id"
                              @input="on_change_delivery_location"
                              label="title"
                              :reduce="item => item.id"
                              :options="this.delivery_locations"
                              :filterable="false"
                    >
                        <template slot="option" slot-scope="option">
                            <div class="d-center">
                                {{ option.title }}
                                <div>
                                    {{option.uniq_id}}
                                    <span v-if="option.hasOwnProperty('linked_restaurant')">
                                        <span v-if="option.linked_restaurant!= null && option.linked_restaurant.hasOwnProperty('title')">
                                            {{option.linked_restaurant.title}}
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </template>
                    </v-select>
                </div>

                <div class="payments_filter">
                    <div class="form-group mt-2">
                        <label class="form-label" for="advanced_name">
                            {{__t('DELIVERY.FILTER_PAYMENTS')}}
                        </label>

                        <div class="input-group flex-nowrap">
                            <b-form-radio-group
                                id="btn-radios-1"
                                v-model="filter_payment"
                                @change="on_change_payments"
                                button-variant="outline-primary"
                                :options="payments_filter_options"
                                name="radios-btn-default"
                                buttons
                            ></b-form-radio-group>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import yes_no from "../../../../sys/radio/yes_no.vue";
import {mapGetters} from "vuex";
import vSelect from 'vue-select';
import Fuse from 'fuse.js';

export default {
    name: "delivery_block" ,
    props : {
        location: {
            type : Object,
        }
    },

    components: {
        yes_no,
        vSelect
    },
    data() {
        return {
            location_loaded : false,
            enable_delivery : false,
            active_location : null,
            filter_payment : "all",
        }
    },

    mounted() {
        this.set_defaults();
    },

    methods : {
        on_change_delivery_location() {
            this.$emit('on_change_delivery_settings',this.send_form)
        },

        on_change_value(val) {
            if(!this.enable_delivery) {
                this.location_loaded = null;
            }

            this.$emit('on_change_delivery_settings',this.send_form)
        },

        on_change_payments() {
            this.$emit('on_change_delivery_settings',this.send_form)
        },

        set_defaults() {


            if(this.location_delivery.id > 0) {
                this.enable_delivery = true;
                this.active_location = this.location_delivery.delivery_location_id;
                this.filter_payment = this.location_delivery.filter_payment;

            }
            else {
                this.enable_delivery = false;
                this.active_location = null;
                this.filter_payment = 'all';
            }
        },

    },

    computed: {

        ...mapGetters({
            'delivery_locations': "deliveries/getDeliveryLocations",
            'providers': "deliveries/getDeliveryProviders"
        }),


        send_form() {
            return {
                "enable_delivery" : this.enable_delivery,
                "location_id"     : this.active_location,
                "filter_payment"  : this.filter_payment,
            }
        },


        payments_filter (){
            return [
                {"type" : "cash"},
                {"type" : "online"},
                {"type" : "all"}
            ];
        },

        payments_filter_options () {
            return this.payments_filter.map(item => {
                item.text = this.__t('PAYMENT.' + item.type.toUpperCase());
                item.value = item.type;

                return item;
            }) ;
        },

        location_delivery() {

            if(this.obj_to_null(this.location) && this.location.hasOwnProperty("delivery_auto")) {
                if(this.obj_to_null(this.location.delivery_auto)) {
                    if (this.location.delivery_auto.hasOwnProperty("id")) {
                        return this.location.delivery_auto;
                    }
                }
            }

            return {
                "delivery_location_id" : 0,
                "id" : 0
            };
        },


        /*is_store_delivery : {
            get() {
                return this.location_delivery.id > 0 && this.enable_delivery;
            },
            set(newValue) {

            }
        },

        active_delivery_location : {
            get() {

                return this.location_delivery.delivery_location_id;
            },
            set(newValue) {
                this.active_location = newValue;
                this.location_delivery.delivery_location_id = newValue;
            }
        },*/


        selected_delivery() {
            let delivery = null;
            if(this.active_location != null && parseInt(this.active_location) > 0) {
                this.delivery_locations.map(item => {
                    if(parseInt(item.id) === parseInt(this.active_location)) {
                        delivery = item;
                    }
                });
            }

            return delivery;
        },

        selected_delivery_rest() {
            if(this.selected_delivery.hasOwnProperty("id")) {
                return parseInt(this.selected_delivery.link_id);
            }
            return 0;
        },

        is_rest_same() {
            try {
                if (this.selected_delivery_rest > 0) {
                    return this.selected_delivery_rest == this.location.link_id;
                }
            }
            catch (e) {

            }

            return true;
        }





    },
}
</script>



<style scoped>

</style>
